import { FormsModule }           from '@angular/forms';
import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { ChartsModule }              from '../shared/components/charts/charts.module';
import { CustomersTabComponent }     from './tabs/intelligence.customers-tab.component';
import { DateRangePickerComponent }  from './intelligence.date-range-picker.component';
import { DealershipTabComponent }    from './tabs/intelligence.dealership-tab.component';
import { FilterComponent }           from './intelligence.filter.component';
import { InspectionsTabComponent }   from './tabs/intelligence.inspections-tab.component';
import { IntelligenceComponent }     from './intelligence.component';
import { IntelligenceStates }        from './intelligence.states';
import { KpiCardComponent }          from './charts/intelligence.kpi-card.component';
import { MechanicsTabComponent }     from './tabs/intelligence.mechanics-tab.component';
import { MoneyTabComponent }         from './tabs/intelligence.money-tab.component';
import { OperationsTabComponent }    from './tabs/intelligence.operations-tab.component';
import { OpportunitiesTabComponent } from './tabs/intelligence.opportunities-tab.component';
import { OverviewTabComponent }      from './tabs/intelligence.overview-tab.component';
import { ProductsTabComponent }      from './tabs/intelligence.products-tab.component';
import { PurchasingTabComponent }    from './tabs/intelligence.purchasing-tab.component';
import { SharedModule }              from '../shared/shared.module';
import { VehiclesTabComponent }      from './tabs/intelligence.vehicles-tab.component';

@NgModule({
  declarations: [
    CustomersTabComponent,
    DateRangePickerComponent,
    DealershipTabComponent,
    FilterComponent,
    InspectionsTabComponent,
    IntelligenceComponent,
    KpiCardComponent,
    MechanicsTabComponent,
    MoneyTabComponent,
    OperationsTabComponent,
    OpportunitiesTabComponent,
    OverviewTabComponent,
    ProductsTabComponent,
    PurchasingTabComponent,
    VehiclesTabComponent
  ],
  entryComponents: [
    IntelligenceComponent
  ],
  imports: [
    ChartsModule,
    FormsModule,
    SharedModule,

    UIRouterUpgradeModule.forChild({ states: IntelligenceStates })
  ]
})
export class IntelligenceModule {}
